<!-- eslint-disable vue/no-mutating-props -->
<template>
  <div>
    <b-overlay
      :show="__isOnLoad"
      variant="white"
      rounded
      opacity="0.70"
      spinner-variant="primary"
      spinner-small
    >
      <div class="editionPanel productDetailPopup">
        <div class="productDetailHead">
          <div>
            <div class="productDetailEyebrow">Catalogue ITTEC P&amp;M</div>
            <h3 class="productTitle">{{ __item.name || "Article catalogue" }}</h3>
            <div class="productDetailSubtitle">
              Consultez la fiche de l'article, ajustez la quantité puis ajoutez-le directement à votre demande de devis.
            </div>
          </div>

          <div v-if="isOnDevis" class="productStateBadge">
            Déjà dans votre devis
          </div>
        </div>

        <div class="productDetailLayout">
          <div class="productDetailMain">
            <div class="productPopupLayout">
              <div class="productMediaCard">
                <div class="productMedia">
                  <img :src="getTof(__item.pic)" class="productImage" alt="Produit catalogue" />
                </div>

                <div class="productMediaMeta">
                  <div class="productMediaMetaLabel">Référence</div>
                  <div class="productMediaMetaValue">{{ __item.ref || "Non renseignée" }}</div>
                </div>
              </div>

              <div class="productInfo">
                <div class="productMetaGrid">
                  <div class="productMetaCard">
                    <div class="productMetaLabel">Référence</div>
                    <div class="productMetaValue">{{ __item.ref || "Non renseignée" }}</div>
                  </div>
                  <div class="productMetaCard">
                    <div class="productMetaLabel">Catégorie</div>
                    <div class="productMetaValue">{{ __item.catID || "Non renseignée" }}</div>
                  </div>
                  <div class="productMetaCard">
                    <div class="productMetaLabel">Marque</div>
                    <div class="productMetaValue">{{ __item.marqueID || "Non renseignée" }}</div>
                  </div>
                </div>

                <div class="productDescriptionCard">
                  <div class="productSectionTitle">Description</div>
                  <p class="productDescription">
                    {{ normalizedDescription }}
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div class="productActionPanel">
            <div class="productActionPanelCard">
              <div class="productSectionTitle">Actions rapides</div>

              <div class="productQty">
                <label class="productQtyLabel">Quantité souhaitée</label>
                <base-input
                  placeholder="Quantité"
                  v-model="qte"
                  type="num"
                  :range="{ min: 1 }"
                  :error="errorCtrl"
                >
                </base-input>
              </div>

              <button
                v-if="!isOnDevis"
                type="button"
                class="productActionBtn productActionBtn-primary"
                @click="AddTobasket()"
              >
                <b-icon icon="cart-plus-fill" aria-hidden="true"></b-icon>
                <span>Ajouter au devis</span>
              </button>

              <button
                v-else
                type="button"
                class="productActionBtn productActionBtn-primary"
                @click="EditBasket()"
              >
                <b-icon icon="check-circle-fill" aria-hidden="true"></b-icon>
                <span>Mettre à jour le devis</span>
              </button>

              <button
                v-if="isOnDevis"
                type="button"
                class="productActionBtn productActionBtn-danger"
                @click="RemoveFromBasket()"
              >
                <b-icon icon="trash-fill" aria-hidden="true"></b-icon>
                <span>Retirer du devis</span>
              </button>

              <button
                v-if="hasTechnicalSheet"
                type="button"
                class="productActionBtn productActionBtn-soft"
                @click="openTechnicalSheet"
              >
                <b-icon icon="file-earmark-pdf-fill" aria-hidden="true"></b-icon>
                <span>Fiche technique</span>
              </button>

              <button
                type="button"
                class="productActionBtn productActionBtn-secondary"
                @click="$emit('close')"
              >
                <b-icon icon="x-circle-fill" aria-hidden="true"></b-icon>
                <span>Fermer</span>
              </button>

              <div class="productActionHint">
                {{ isOnDevis ? "Cet article est déjà présent dans votre demande de devis." : "Ajoutez cet article à votre panier devis en un clic." }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-overlay>
  </div>
</template>
<script>
import Vue from "vue";
export default {
  components: {},
  computed: {
    normalizedDescription() {
      return this.$props.__item.desc || "Aucune description détaillée n'est disponible pour cet article pour le moment.";
    },
    hasTechnicalSheet() {
      return !!(this.$props.__item.fiche && String(this.$props.__item.fiche).trim() !== "");
    },
  },
  props: {
    __isOnLoad: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    __item: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data: () => {
    return {
      fullList: [],
      errorCtrl: [],
      qte: 1,
      ddevis: [],
      isOnDevis: false,
    };
  },
  methods: {
    getTof(c) {
      return this.__.resolveMediaPath(c, 'uploads/catalogue/No-Image.jpg');
      // return 'http://localhost:5000/uploads/'+c.split("/uploads/")[1];
      // return './uploads/'+c.split("/uploads/")[1];
    },

    AddTobasket() {
      this.ddevis.push({
        id: this.$props.__item._id,
        name: this.$props.__item.name,
        ref: this.$props.__item.ref,
        pic: this.$props.__item.pic,
        qte: this.qte,
        isValide: false,
        prix: this.$props.__item.prixV,
        type: this.$props.__item.typeArticle,
        remise: 0,
        total: 0,
      });
      Vue.$cookies.set("devis", this.ddevis);
      this.isOnDevis = true;
    },

    EditBasket() {
      this.ddevis = this.ddevis.map((e) => {
        if (e.id !== this.$props.__item._id) {
          return e;
        }
        return {
          ...e,
          qte: this.qte,
        };
      });
      Vue.$cookies.set("devis", this.ddevis);
    },

    RemoveFromBasket() {
      this.ddevis = this.ddevis.filter((e) => e.id !== this.$props.__item._id);
      Vue.$cookies.set("devis", this.ddevis);
      this.isOnDevis = false;
      this.qte = 1;
    },

    openTechnicalSheet() {
      if (!this.hasTechnicalSheet) {
        return;
      }
      window.open(this.$props.__item.fiche, "_blank", "noopener");
    },

    dispatchSave() {
      //Vue.$cookies.set('user',response.data[0]);
    },
  },
  mounted() {
    this.ddevis = Vue.$cookies.get("devis") || [];
    this.isOnDevis =
      this.ddevis.filter((e) => {
        if(e.id === this.$props.__item._id)
        {
          this.qte = e.qte
          return true
        }
        return false
      }).length > 0;
 
  },

  watch: {},
};
</script>
<style>
.modal-xl {
  max-width: 85% !important;
}
.editionPanel.productDetailPopup {
  width: 100%;
  padding: 18px;
  margin-bottom: 0;
  border-radius: 22px;
  background: linear-gradient(180deg, #ffffff 0%, #f6f9fc 100%);
  display: flex;
  flex-direction: column;
  gap: 18px;
}

.productDetailHead {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 14px;
  padding: 4px 4px 0;
}

.productDetailEyebrow {
  color: #f1851b;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  margin-bottom: 8px;
}

.productDetailSubtitle {
  max-width: 640px;
  color: #64748b;
  font-size: 14px;
  line-height: 1.6;
}

.productStateBadge {
  flex: 0 0 auto;
  padding: 8px 12px;
  border-radius: 999px;
  background: linear-gradient(135deg, rgba(29, 185, 84, 0.16) 0%, rgba(25, 135, 84, 0.12) 100%);
  border: 1px solid rgba(25, 135, 84, 0.24);
  color: #1f7a45;
  font-size: 12px;
  font-weight: 700;
}

.productDetailLayout {
  display: grid;
  grid-template-columns: minmax(0, 1.35fr) minmax(260px, 0.65fr);
  gap: 18px;
  align-items: start;
}

.productDetailMain,
.productActionPanelCard {
  padding: 16px;
  border-radius: 20px;
  border: 1px solid #e2e8f0;
  background: rgba(255, 255, 255, 0.92);
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.06);
}

.productPopupLayout {
  display: grid;
  grid-template-columns: minmax(260px, 340px) minmax(0, 1fr);
  gap: 18px;
  align-items: start;
}

.productMediaCard {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.productMedia {
  background: linear-gradient(180deg, #f8fbfe 0%, #eef3f7 100%);
  border: 1px solid #e5ebf3;
  border-radius: 18px;
  padding: 14px;
  min-height: 292px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.productImage {
  width: 100%;
  max-height: 260px;
  display: block;
  border-radius: 12px;
  object-fit: contain;
  mix-blend-mode: darken;
}

.productMediaMeta {
  padding: 12px 14px;
  border-radius: 16px;
  background: linear-gradient(180deg, #f8fbff 0%, #edf3fa 100%);
  border: 1px solid #dfE7f1;
}

.productMediaMetaLabel,
.productMetaLabel,
.productSectionTitle {
  color: #6b7b93;
  font-size: 11px;
  font-weight: 800;
  text-transform: uppercase;
  letter-spacing: 0.06em;
}

.productMediaMetaValue,
.productMetaValue {
  margin-top: 6px;
  color: #1e2a44;
  font-size: 14px;
  font-weight: 700;
  line-height: 1.45;
  word-break: normal;
  overflow-wrap: anywhere;
}

.productInfo {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.productMetaGrid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.productMetaCard,
.productDescriptionCard {
  padding: 14px 16px;
  border-radius: 18px;
  background: linear-gradient(180deg, #f9fbff 0%, #f1f5fa 100%);
  border: 1px solid #e2e8f0;
}

.productTitle {
  margin: 0 0 8px;
  font-size: 30px;
  line-height: 1.2;
  color: #1e2a44;
  font-weight: 800;
}

.productDescription {
  margin: 10px 0 0;
  color: #42526b;
  line-height: 1.6;
  white-space: pre-line;
  font-size: 14px;
}

.productDescriptionCard {
  grid-column: 1 / -1;
}

.productQty {
  width: 100%;
}

.productQtyLabel {
  display: block;
  margin-bottom: 6px;
  color: #4b587c;
  font-size: 13px;
  font-weight: 600;
}

.productActionPanelCard {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.productActionBtn {
  width: 100%;
  min-height: 46px;
  border: 0;
  border-radius: 14px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 700;
  transition: transform 0.18s ease, box-shadow 0.18s ease, opacity 0.18s ease;
}

.productActionBtn:hover {
  transform: translateY(-1px);
}

.productActionBtn-primary {
  background: linear-gradient(135deg, #102147 0%, #24365f 100%);
  color: #fff;
  box-shadow: 0 14px 28px rgba(16, 33, 71, 0.2);
}

.productActionBtn-secondary {
  background: #eef3f8;
  color: #1e2a44;
  border: 1px solid #d9e2ec;
}

.productActionBtn-danger {
  background: linear-gradient(135deg, #f85f73 0%, #e53935 100%);
  color: #fff;
  box-shadow: 0 14px 28px rgba(229, 57, 53, 0.18);
}

.productActionBtn-soft {
  background: linear-gradient(135deg, rgba(241, 133, 27, 0.14) 0%, rgba(255, 210, 161, 0.2) 100%);
  color: #9a4d00;
  border: 1px solid rgba(241, 133, 27, 0.22);
}

.productActionHint {
  padding: 12px 14px;
  border-radius: 14px;
  background: #f8fbff;
  border: 1px solid #e4ecf5;
  color: #5f6f8b;
  font-size: 13px;
  line-height: 1.5;
}

.form-control option {
  color: black;
}

@media (max-width: 768px) {
  .modal-xl {
    max-width: 95% !important;
    margin: 10px auto;
  }
  .editionPanel.productDetailPopup {
    padding: 14px;
  }

  .productDetailHead,
  .productDetailLayout,
  .productPopupLayout {
    grid-template-columns: 1fr;
    gap: 16px;
  }

  .productDetailHead {
    align-items: flex-start;
  }

  .productMetaGrid {
    grid-template-columns: 1fr;
  }

  .productDescriptionCard {
    grid-column: auto;
  }

  .productMedia {
    min-height: 220px;
  }

  .productImage {
    max-height: 190px;
  }
}
</style>
